import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosController.php
* @route '/api/partners/fetch-enaos/{dossier}'
*/
const FetchDossierEnaosController6c9824bf8e131cdeab8936f5fa148f9f = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierEnaosController6c9824bf8e131cdeab8936f5fa148f9f.url(args, options),
    method: 'post',
})

FetchDossierEnaosController6c9824bf8e131cdeab8936f5fa148f9f.definition = {
    methods: ["post"],
    url: '/api/partners/fetch-enaos/{dossier}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosController.php
* @route '/api/partners/fetch-enaos/{dossier}'
*/
FetchDossierEnaosController6c9824bf8e131cdeab8936f5fa148f9f.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierEnaosController6c9824bf8e131cdeab8936f5fa148f9f.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosController.php
* @route '/api/partners/fetch-enaos/{dossier}'
*/
FetchDossierEnaosController6c9824bf8e131cdeab8936f5fa148f9f.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierEnaosController6c9824bf8e131cdeab8936f5fa148f9f.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
const FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617 = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617.url(args, options),
    method: 'get',
})

FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/enaos',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosController::FetchDossierEnaosController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `FetchDossierEnaosController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const FetchDossierEnaosController = {
    '/api/partners/fetch-enaos/{dossier}': FetchDossierEnaosController6c9824bf8e131cdeab8936f5fa148f9f,
    '/api/dossier/{dossier}/enaos': FetchDossierEnaosController8425c1da45f8d483834d1296cc7c1617,
}

export default FetchDossierEnaosController